import React from "react";
import LiveTradingTest from "../trading/LiveTradingTest";
import { useWorkspace } from "../../context/WorkspaceContext";
import { useUiStore, useChartBridge } from "../../store/uiStore";
import { confluenceStore } from "../../lib/confluenceStore";
import { meta } from "../../lib/symbols";
import { CheckCircle, MinusCircle } from "@phosphor-icons/react";

// Trade utility: compact FELA R.I.O SETUP context + the ONE existing Deriv DEMO execution path (server safety layer).
export default function TradePanel() {
  const ws = useWorkspace();
  const { tradeIntent } = useUiStore();
  const { bridge } = useChartBridge();
  const snap = confluenceStore.snapshot(ws.symbol);
  const st = bridge?.structure;
  const lastEv = st?.events?.length ? st.events[st.events.length - 1] : null;
  const bias = snap ? (snap.bull > snap.bear ? "BULLISH" : snap.bear > snap.bull ? "BEARISH" : "NEUTRAL") : null;
  const comp = (id) => snap?.components?.[id];
  const has = (id) => { const c = comp(id); return !!c && (c.bull > 0 || c.bear > 0); };
  const rows = [
    ["BOS / CHoCH", !!lastEv, lastEv ? `${lastEv.type} ${lastEv.dir}` : "—"],
    ["CISD", !!st?.cisd?.events?.length, st?.cisd?.state || "—"],
    ["FVG", has("fvg"), comp("fvg")?.state || "—"],
    ["Liquidity", has("sweep"), comp("sweep")?.state || "—"],
    ["Displacement", has("displacement"), comp("displacement")?.state || "—"],
    ["Tick dominance", has("tickDominance"), comp("tickDominance")?.state || "—"],
  ];
  return (
    <div data-testid="trade-panel">
      <div className="m-2 rounded-lg border border-border p-2.5 text-xs" data-testid="trade-setup">
        <div className="flex items-center gap-2"><span className="text-[10px] uppercase tracking-widest text-primary font-bold">Fela R.I.O setup</span><span className="text-muted-foreground">{meta(ws.symbol).display} · {ws.tf.id}</span>
          {bias && <span data-testid="trade-setup-bias" className={`ml-auto font-bold ${bias === "BULLISH" ? "text-buy" : bias === "BEARISH" ? "text-sell" : "text-muted-foreground"}`}>{bias}</span>}</div>
        <div className="mt-1 font-mono-nums" data-testid="trade-setup-score">Confluence {snap ? `${Math.max(snap.bull, snap.bear)}/100` : "n/a"} <span className="text-muted-foreground">(bull {snap?.bull ?? "–"} · bear {snap?.bear ?? "–"})</span></div>
        <div className="mt-1.5 grid grid-cols-2 gap-x-3 gap-y-0.5">
          {rows.map(([l, ok, d]) => <div key={l} className="flex items-center gap-1.5 truncate">{ok ? <CheckCircle size={12} weight="fill" className="text-buy shrink-0" /> : <MinusCircle size={12} className="text-muted-foreground shrink-0" />}<span className={ok ? "" : "text-muted-foreground"}>{l}</span><span className="text-[10px] text-muted-foreground truncate">{d}</span></div>)}
        </div>
        <p className="text-[10px] text-muted-foreground mt-1.5">Informational — the server-side Decision Gate decides. Snapshot travels with the trade.</p>
      </div>
      <LiveTradingTest key={`${ws.symbol}-${tradeIntent?.at ?? 0}`} symbol={ws.symbol} compact initialType={tradeIntent?.ctype} />
    </div>
  );
}
